import { useEffect } from "react";
import { subscribeAccessRevoked } from "../services/dashboardApi";

// Bridges the API layer's access-revoked broadcast to a page-level reaction for
// as long as that page is mounted. Section switching is local tab state rather
// than routing, so neither the route guards nor the page-level fetch re-run on
// it; this subscription is what lets a rejection from *any* in-section request
// reach the page that owns the invalid-link screen.
//
// `onRevoked` must be referentially stable (useCallback) — an inline function
// would resubscribe on every render.
export function useDashboardAccessGuard(onRevoked) {
  useEffect(() => subscribeAccessRevoked(onRevoked), [onRevoked]);
}
